import React from 'react'
import ModifiedHelmet from './modified-helmet'
import Layout from './layout'
import TruncatedHtml from './truncated-html'
import HeroTitleBlock from './hero-title-block'
import Sponsor from "./sponsor"
import moment from "moment"
import EventHours from './event-hours'
import DiscoverMore from "./discover-more"
import ResultCard from './result-card'
import NavigationNode from './navigation-node'
import ResultFeed from './result-feed'
import ItemSponsor from './item-sponsors'
import { FiMapPin } from 'react-icons/fi';
import Icon from '@mdi/react';
import { mdiHandPointingRight } from '@mdi/js';
import {useAllEventData} from '../hooks/events'
import {useAllCategoryData} from '../hooks/categories'
import pluralize from 'pluralize'
import ReactPlayer from "react-player"

import clone from 'lodash/clone';

import {groupBy} from 'lodash';

export default ({ settings, deals, activities, vendors, services, locatable: {heroImage, seoMetaTags, title, subtitle, summary, description,
  videoUrl, requiresTicket, presaleStart, presaleEnd, saleStart, saleEnd, showareUrl, scheduleItems,
  universalTags, subcategories, location, locations, sponsors, itemSponsors, events, model, pageHeader, discoverMore, heightRequirements }}) => {
  const allCategories = useAllCategoryData()
  const category = allCategories.find(category => model.apiKey === pluralize.singular(category.title).toLowerCase())
  const hasSubcategories =  subcategories && subcategories.length !== 0
  const hasUniversalTags = universalTags && universalTags.length !== 0
  const hasVendors = vendors && vendors.length !== 0
  const hasServices = services && services.length !== 0
  const hasActivities = activities && activities.length !== 0
  const hasLocations = locations && locations.length !== 0
  const building = (location && location.building) || ( hasLocations && locations.length === 1 && locations.find(l => l.building) && locations.find(l => l.building).building )

  const discoverMoreWidget = discoverMore || (hasSubcategories && subcategories[0].landingPageDiscoverMore ) || category.landingPageDiscoverMore
  const heroTitleBlockWidget = pageHeader || (hasSubcategories && subcategories[0].heroTitleBlock)
  const sponsorWidget = sponsors || (hasSubcategories && subcategories[0].sponsors) || (settings && settings.sponsors)
  const hasRideHours = (events && model && model.apiKey) === "ride"
  const isThrillVille = hasSubcategories && subcategories.find((s) => s.title && (s.title.toLowerCase().includes('thrillville')))
  const displayTicketPurchaseOption = () => {
    if(!requiresTicket) { return false; }
    let withinSaleWindow;
    let withinPreSaleWindow;
      if(saleStart !== null && saleEnd !== null){
        withinSaleWindow = moment().isAfter(moment(saleStart)) && moment().isBefore(moment(saleEnd));
      } else if ( saleStart === null && saleEnd !== null ) {
        withinSaleWindow = moment().isBefore(moment(saleEnd));
      } else if ( saleStart !== null && saleEnd === null ) {
        withinSaleWindow =  moment().isAfter(moment(saleStart));
      } else {
        withinSaleWindow = "blank";
      }

    if(presaleStart !== null && presaleEnd !== null){
      withinPreSaleWindow = moment().isAfter(moment(presaleStart)) && moment().isBefore(moment(presaleEnd));
    } else if ( presaleStart === null && presaleEnd !== null ) {
      withinPreSaleWindow = moment().isBefore(moment(presaleEnd));
    } else if ( presaleStart !== null && presaleEnd === null ) {
      withinPreSaleWindow =  moment().isAfter(moment(presaleStart));
    } else {
      withinPreSaleWindow = "blank";
    }
    if (withinSaleWindow === "blank" && withinPreSaleWindow === "blank") { return true }
    if ( withinSaleWindow === "blank") {
      withinSaleWindow = false;
    }
    if ( withinPreSaleWindow === "blank") {
      withinPreSaleWindow = false;
    }
    return (withinSaleWindow || withinPreSaleWindow);
  }
  let sections = null
  if (scheduleItems) {
    const closedDays = useAllEventData().flatMap((event) => event.days).filter((day) => !day.open)
    // TODO: a lot of duplicated code from ResultFeed
    let expandedScheduleItems = scheduleItems
      .flatMap(scheduleItem => {
        const startDate = moment(scheduleItem.startDate  || undefined);
        const endDate = moment(scheduleItem.endDate || undefined);
        const numberOfOccurances = Math.max(Math.abs(startDate.diff(endDate, 'days')) + 1, 1);
        return ((n) => {
          let returnVal = [];
          for(let i = 0; i < n; i++){
            const date = startDate.format("YYYY-MM-DD");
            startDate.add(1, 'day');
            returnVal.push(date);
          }
          return returnVal;
        })(numberOfOccurances)
          .map(date => {
            const recurring = clone(scheduleItem);
            const isClosed = closedDays.find((day) => moment(day.date).isSame(date, 'day'))

            recurring.startDate = date;
            recurring.endDate = date;
            recurring.startTime = isClosed ? null : (scheduleItem.startTime || "12:00 AM")
            recurring.endTime = scheduleItem.endTime || "11:59 PM"
            recurring.id = scheduleItem.id + "-" + date + "-" + (scheduleItem.startTime || "allday");
            return recurring;
          })
      })
      .filter(sI => moment().isSameOrBefore(moment(sI.endDate + " " + sI.endTime, "YYYY-MM-DD h:m A")))
      .sort((a,b) => {
        if (!a && b) return -1;
        if (a && !b) return 1;
        if (!a && !b) return 0;
        const {startDate: aStartDate, startTime: aStartTime} = a;
        const {startDate: bStartDate, startTime: bStartTime} = b;
        const aStartDateTime = moment(aStartDate + " " + aStartTime, "YYYY-MM-DD h:m A");
        const bStartDateTime = moment(bStartDate + " " + bStartTime, "YYYY-MM-DD h:m A");
        return aStartDateTime - bStartDateTime;
      })

    const groupedLocatables = groupBy(expandedScheduleItems, (i) => (i.startDate));
    sections = Object.keys(groupedLocatables).map((key) => {
      return { id: key, title: moment().isSame(key, 'day') ? "Today" : moment(key).format("ddd, MMM D"), scheduleItems: groupedLocatables[key] };
    });

  }
  return (
    <Layout>
      <ModifiedHelmet seo={seoMetaTags} />
      {heroTitleBlockWidget && (
        <HeroTitleBlock widget={heroTitleBlockWidget} />
      )}
      <section className="uk-section">
        <div className="uk-container uk-container-expand">
          <div uk-grid="">
            <div className="uk-width-1-1 uk-width-2-3@m ">
              { heroImage && (
                <div className="height-hero uk-background-cover uk-background-norepeat uk-background-top-center uk-position-relative"  data-src={`${heroImage && heroImage.url}?w=2200`} data-sizes={heroImage && heroImage.fluid.sizes} uk-img="">
                  {
                    (hasSubcategories || hasUniversalTags) && (
                      <div className="uk-position-cover">
                        <div className="uk-overlay uk-overlay-primary uk-position-bottom">
                          <span className="uk-text-uppercase">
                            {hasSubcategories && subcategories[0].title}
                          </span>
                          {hasSubcategories && hasUniversalTags &&
                            <span>&nbsp;•&nbsp;</span>
                          }
                          {hasUniversalTags && universalTags.map((tag) => tag.title).join(", ")}
                        </div>
                      </div>
                    )
                  }
                </div>
              )}
            </div>
            <div className="uk-width-1-1 uk-width-1-3@m padding-right@m">
              {
                title && (
                  <h1 style={{marginBottom: "12px"}} className="margin-responsive-medium-up text-saddle">{title}</h1>
                )
              }
              {
                subtitle && (
                  <h3 className="uk-text-uppercase uk-margin-small-top">{subtitle}</h3>
                )
              }
              {heightRequirements && (
                <div className="uk-flex" style={{fontSize: "15px"}}>
                  <Icon path={mdiHandPointingRight} color="#63584A" size={.75} style={{marginRight: "3px", marginTop: "3px"}} />
                  <span className="small text-accessible-cement uk-margin-remove">
                  Height requirements: {heightRequirements}</span>
                </div>
              )}
              {(location || hasLocations) && (
                <div className="small " style={{marginBottom: "10px", marginTop: "2px", fontSize: "15px"}}>
                  <span className="text-cement"><FiMapPin style={{marginRight: "5px", paddingBottom: "4px"}}  /></span>
                  <span className="text-accessible-cement">
                  {building && (
                    <NavigationNode locatable={building }  className="uk-text-primary uk-text-bold">{building.title}</NavigationNode>
                  )}
                  {!building && (
                      <>
                      {location && location.title}
                      {locations && (locations.length === 1) && locations[0].title}
                      {locations && (locations.length > 1) && "Multiple locations"}
                      </>
                    )
                  }
                  </span>
                </div>
              )}

              {
                summary && (
                  <div className="uk-text-bold text-saddle" dangerouslySetInnerHTML={{__html: summary }}></div>
                )
              }
              { displayTicketPurchaseOption() && (
                <a href={showareUrl} className="uk-button uk-button-primary">Buy tickets</a>
               )
              }
              {
                itemSponsors &&
                  <ItemSponsor widget={itemSponsors} />
              }
            </div>
          </div>
        </div>
      </section>
      <section className="uk-section uk-background-muted">
        <div className="uk-container uk-container-xsmall uk-padding-remove">
          <div className="uk-card uk-card-default background-transparent">
            <ul className="uk-child-width-expand" uk-tab="">
              {description && (
                <li><a href="#description">Details</a></li>
              )}
              {videoUrl && (
                <li><a href="#listen">Video</a></li>
              )}
              {scheduleItems && (
                <li><a href="#schedule">Schedule</a></li>
              )}
              {hasRideHours && (
                <li><a href="#hours">Hours</a></li>
              )}
              {deals && deals.length !== 0 && (
                <li><a href="#deals">Deals & Discounts</a></li>
              )}
              {hasActivities && (
                <li><a href="#schedule">Schedule</a></li>
              )}
              {hasServices && (
                <li><a href="#services">Services</a></li>
              )}
              {hasVendors && (
                <li><a href="#vendors">Food</a></li>
              )}
            </ul>
            <ul className="uk-switcher">
              {description && (
                <li className="uk-padding"><TruncatedHtml body={description} /></li>
              )}
              {videoUrl && (
                <li className="uk-padding">
                  <ReactPlayer url={videoUrl} controls />
                </li>
              )}
              {scheduleItems  && (
                <li className="padding@s">
                  {
                    sections.length !== 0 ? sections.map((section) => (
                      <div key={section} className="">
                        <h6 className="uk-text-uppercase uk-margin-left uk-margin-small">{section.title}</h6>
                        {
                          section.scheduleItems.map((scheduleItem, i) => (
                            <div className="uk-flex uk-flex-between card-border uk-margin-small-bottom">
                              <span>{scheduleItem.title || title}</span>
                              <div
                                style={{textAlign: "right"}}
                              >
                                <span className="uk-text-bold uk-text-nowrap uk-margin-medium-left"
                                >{scheduleItem.startTime ? scheduleItem.startTime : "Closed"}</span>
                                {(scheduleItem.endTime && scheduleItem.startTime) &&
                                  <span className="uk-text-bold uk-text-nowrap"> &ndash; {scheduleItem.endTime}</span>
                                }
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    )) : <p className="uk-text-center">No scheduled dates at this time.</p>
                  }
                </li>
              )}
              {hasRideHours && events.flatMap(ev => ev.days).length !== 0 && (
                <li className="padding@s">
                  <EventHours events={events} isThrillVille={isThrillVille} isRide={hasRideHours} />
                </li>
              )}
              {deals && deals.length !== 0 && (
                <li className="uk-padding">
                  {
                    deals.map((deal, i )=> <ResultCard key={i} locatable={deal} />)
                  }
                </li>
              )}
              {hasActivities && (
                <li className="padding@s"><ResultFeed locatables={activities} visibleItems={12} isSchedule={true} /></li>
              )}
              {hasServices && (
                <li className="padding@s"><ResultFeed locatables={services} visibleItems={12} isSchedule={false} /></li>
              )}
              {hasVendors && (
                <li className="padding@s"><ResultFeed locatables={vendors} visibleItems={12} isSchedule={false} /></li>
              )}
            </ul>
          </div>
        </div>
      </section>
      {
        discoverMoreWidget && (
          <DiscoverMore widget={discoverMoreWidget} />
        )
      }
      {
        sponsorWidget && (
          <Sponsor widget={sponsorWidget}/>
        )
      }

    </Layout>
  )
}
